import Index from '../../pages/hjwq/kfhd/index';
import Help from '../../pages/hjwq/kfhd/help';
import Query from '../../pages/hjwq/kfhd/query';
import Pc from '../../pages/hjwq/kfhd/pc';

const base = 'kfhd';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/help*`,
    name: `${base}-help`,
    component: Help
  },
  {
    path: `/${base}/query*`,
    name: `${base}-query`,
    component: Query
  },
  {
    path: `/${base}/pc*`,
    name: `${base}-pc`,
    component: Pc
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/hjwq/kfhd.js